import createHistory from 'history/createHashHistory';
import ViewScrollState from 'commons/ScrollView/ViewScrollState.js';
import { Alert } from 'commons/Modal';
import { sessionStorageHelper } from 'tools/StorageHelper';
import { getRequestParams } from 'tools/utils';
import { isHaojieApp, isNoLogin, is58App } from 'api/Helper';

import { gotoLogin, gotoBindMobile } from 'api/Login';

const prefix = '@History/';
const hashHistory = createHistory();

/**
 * 存储state
 * @param {*} search location对象中的search
 * @param {*} state location对象中的state
 */
const saveState = (search, state) => {
    const key = getRequestParams(search.substr(1))._k;
    key && sessionStorageHelper.setItem(`${prefix}${key}`, JSON.stringify(state));
};

/**
 * 读取state
 * @param {String} location对象中的search
 */
const getState = (search) => {
    const key = getRequestParams(search.substr(1))._k;
    return key && sessionStorageHelper.getItem(`${prefix}${key}`);
};

/**
 * 获取location内的search 并改变location的state
 * 只会在初始化的时候执行一下代码逻辑
 * 为了解决刷新后location的state丢失的问题
 */
if (hashHistory.location.search) {
    const state = getState(hashHistory.location.search);
    if (state) {
        try {
            hashHistory.location.state = JSON.parse(state);
        } catch (e) {
            console.log(e);
        }
    }
}

hashHistory.listen((location, action) => {
    if (location.search && location.state) {
        saveState(location.search, location.state);
    }
    console.log(location);
    if (action === 'PUSH') {
        // 重置ScrollView位置
        ViewScrollState.reset(location.pathname.replace(/\//g, ''));
    }

    disableRefresh();
    // 点击浏览器或者手机前进后退关闭弹框
    Alert.close();
});
let disableRefresh = () => {
    if (isHaojieApp()) {
        window.WBAPP.invoke('need_refresh', {
            state: false,
        });
    }
};
disableRefresh();

hashHistory.openWebView = function (input) {
    // 进行拦截处理
    if (isHaojieApp() || is58App()) {
        if (isNoLogin()) {
            gotoLogin();
            return;
        }
    }
    if (isHaojieApp()) {
        // if (!isBind()) {
        //     gotoBindMobile();
        //     return;
        // }
        // 首页打开新webview
        let _pathname = input;
        let _value = '';
        if (typeof input === 'object') {
            _pathname = input.pathname;
            if (!!input.state && typeof input.state === 'object') {
                _value = JSON.stringify(input.state);
            }
        }
        window.WBAPP.invoke('open_webview', {
            url: `${window.location.origin}${window.location.pathname}#${_pathname}`,
            hide: false,
            key: _pathname,
            value: _value,
        });
    } else if (is58App()) {
        if (window.WBAPP.util.compareVersion(window.WBAPP.common.appVersion, '7.5.0') > 0) {
            window.WBAPP.invoke('is_bind_account', {
                type: 'PHONE',
            }, (state) => {
                if (String(state) === '0') {
                    hashHistory.push(input);
                } else if (String(state) === '1') {
                    gotoBindMobile();
                }
            });
        } else {
            hashHistory.push(input);
        }
    } else {
        hashHistory.push(input);
    }
};
// 获取webview存入的临时数据
hashHistory.propsData = function () {
    let pdata = null;
    if (isHaojieApp()) {
        window.WBAPP.invoke('get_session_storage', {
            key: hashHistory.location.pathname,
            sync: true,
        }, (data) => {
            pdata = { state: data };
        });
    }
    return pdata;
};

hashHistory.goHome = function () {
    if (isHaojieApp()) {
        window.WBAPP.invoke('go_app_tab', { tab: '0' });
    } else {
        hashHistory.replace('/home');
    }
};

export default hashHistory;



// WEBPACK FOOTER //
// ./src/components_common/History/index.js